import type { TypedData } from "abitype";
import { useCallback } from "react";
import type { Account, SignTypedDataParameters } from "viem";
import { useConnection, useSendTransaction, useSwitchChain, useSignMessage, useSignTypedData } from "wagmi";
import type { ChainType } from "../constants";
type SendTransactionArgs = {
  chainId?: number;
  mode?: "prepared";
  to: `0x${string}`;
};
export type SignTypedDataArgs<TTypedData extends TypedData | {
  [key: string]: unknown;
} = TypedData, TPrimaryType extends string = string> = SignTypedDataParameters<TTypedData, TPrimaryType, Account>;
/*
const logEvent = useCallback(
  (event: string) => {
    console.log(`${address}:`, event);
  },
  [address]
);
*/

const logEvent = (event: string) => {
  console.log("App Wallet: ", event);
};
export default function useAppWallet(requestedChain: ChainType) {
  const {
    address,
    chainId
  } = useConnection();
  const {
    sendTransactionAsync
  } = useSendTransaction();
  const {
    signMessageAsync
  } = useSignMessage();
  const {
    signTypedDataAsync
  } = useSignTypedData();
  const {
    switchChainAsync,
    switchChain
  } = useSwitchChain();
  const switchNetwork = useCallback(async () => {
    if (Number(requestedChain) !== chainId) {
      await switchChainAsync({
        chainId: Number(requestedChain)
      });
    }
  }, [chainId, switchChainAsync]);
  const sendTransaction = useCallback(async (transaction: SendTransactionArgs) => {
    await switchNetwork();
    const tx = await sendTransactionAsync(transaction);
    logEvent("Send Transaction");
    return tx;
  }, [sendTransactionAsync, switchNetwork, logEvent]);
  const signMessage = useCallback(async (message: string) => {
    await switchNetwork();
    const signature = await signMessageAsync({
      message
    });
    logEvent("Sign Message");
    return signature;
  }, [signMessageAsync, switchNetwork, logEvent]);
  const signTypedData = useCallback(async (typedData: SignTypedDataArgs) => {
    await switchNetwork();
    if (typedData.domain) {
      typedData.domain.chainId = Number(typedData.domain.chainId);
    }
    const signature_0 = await signTypedDataAsync(typedData);
    logEvent("Sign Typed Data");
    return signature_0;
  }, [signTypedDataAsync, switchNetwork, logEvent]);
  return {
    address,
    sendTransaction,
    signMessage,
    signTypedData
  };
}